import { TableRow, TableCell, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { Job, JobProgressValue } from '../JobTypes';
import format from 'date-fns/format';
import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import JobDataTableRowAddress from './JobDataTableRowAddress';
import { Link } from 'react-router-dom';

interface DataTableRowProps {
  data?: Job
  skeleton?: boolean
}

const JobsDataTableRow = ({data, skeleton}:DataTableRowProps) => {
  const classes = useStyles();

  if(skeleton) {
    return (
    <TableRow className={`${classes.root} ${classes.skeleton}`}>
      <TableCell component="th" scope="row" align="center" colSpan={4}>
        <Skeleton variant="text" />
      </TableCell>
    </TableRow>      
    );
  }
  else if(!data) {
    return (
    <TableRow className={`${classes.root} ${classes.blank}`}>
      <TableCell component="th" scope="row" align="center" colSpan={4}>
        &nbsp;
      </TableCell>
    </TableRow>      
    );
  }

  let rowProgressClassName = classes.Pending;
  if( JobProgressValue[data.progress] === 'InProgress' ) {
    rowProgressClassName = classes.InProgress;
  }
  else if( JobProgressValue[data.progress] === 'Complete' ) {
    rowProgressClassName = classes.Complete;
  }

  let statusChip = <Chip label={data.status} size="small" />;
  if(data.overdue) {
    statusChip = <Chip label='Overdue' size="small" deleteIcon={<ErrorOutlineIcon/>} onDelete={(e)=>e.preventDefault()} />;
  }

  return (
    <TableRow className={`${classes.root} ${data.overdue && data.progress !== JobProgressValue.Complete ? classes.overdue : rowProgressClassName}`}>
      <TableCell component="th" scope="row" align="center">
        <Link to={`/servicerequest/${data.id}`}>{data.requestNumber}</Link>
      </TableCell>
      <TableCell>
        <div className="typeText">{data.type}</div>
        <JobDataTableRowAddress requestId={parseInt(data.id)} />
      </TableCell>
      <TableCell>
        {format(data.date, "dd'/'MM'/'yyyy KK':'mmaaa")}
      </TableCell>
      <TableCell>
        {statusChip}        
      </TableCell>
    </TableRow>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiChip-root': {
      borderRadius: '16px',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    '& .MuiSkeleton-text': {
      marginTop: '2px',
      marginBottom: '2px',
    },
    '& .typeText': {
      fontWeight: 500,
      paddingBottom: theme.spacing(0.5),
    }
  },
  blank: {
    '& .MuiTableCell-body': {
      height: "93px",
    },
  },
  skeleton: {
    '& .MuiTableCell-body': {
      height: "93px",
    },
  },
  Pending: {
    '& .MuiTableCell-body': {
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3',
    },
    '& .MuiChip-root': {
      background: theme.palette.info.main,
      color: '#FFFFFF',
    },
  },
  InProgress: {
    '& .MuiTableCell-body': {
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #FF9800',
    },
    '& .MuiChip-root': {
      background: '#FF9800',
      color: '#FFFFFF',
    },
  },
  Complete: {
    '& .MuiTableCell-body': {
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #4CAF50',
    },
    '& .MuiChip-root': {
      background: theme.palette.success.main,
      color: '#FFFFFF',
    },
  },
  overdue: {
    '& .MuiTableCell-body': {
      background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F0533E',
    },
    '& .MuiChip-root': {
      background: theme.palette.error.dark,
      color: '#FFFFFF',
    },
    '& .MuiChip-deleteIcon': {
      color: '#FFFFFF',
    }
  },
}));


export default JobsDataTableRow;
